import React, { useState, useEffect } from 'react';
import { cloneDeep } from 'lodash-es';
import * as S from './ExcludeSettings.styled';
import { ChooseCategories, Buttons, ParagraphWithTooltip, CustomTooltip } from 'components';
import { DeleteIcon, LockIcon } from 'assets/icons';

const ExcludeCategories = ({ value, onChange }) => {
  const [categories, setAllCategories] = useState([]);
  useEffect(() => {
    if (value?.length > 0) setAllCategories(value);
  }, [value]);

  const showItems = categories.filter((item) => item.selected || item.isGlobal);
  const isSomeNotGlobal = showItems?.some((item) => !item.isGlobal);

  const clearAll = () => {
    const newCategories = cloneDeep(categories);
    newCategories.forEach((cat) => (cat.selected = false));
    setAllCategories(newCategories);
    onChange([]);
  };

  const deleteCategory = (value) => {
    const newCategories = cloneDeep(categories);
    const currentItem = newCategories.find((item) => item.value === value);
    currentItem.selected = false;
    setAllCategories(newCategories);
    onChange(newCategories);
  };

  const handleSaveBtnClick = (data) => {
    setAllCategories(data);
    onChange(data);
  };

  return (
    <>
      <S.TextField>
        <S.Title>Exclude Categories:</S.Title>
        <S.SubTitle>Exclude Google Play categories.</S.SubTitle>
      </S.TextField>
      <S.FieldsWrap>
        <S.ActionField>
          <S.BtnWrap>
            <ChooseCategories
              allCategories={categories}
              setAllCategories={handleSaveBtnClick}
              title='Exclude Categories'
            />
          </S.BtnWrap>
          {showItems.length > 0 && (
            <>
              <S.Line isNoButton={!isSomeNotGlobal} />
              {isSomeNotGlobal && (
                <S.BtnWrapp>
                  <Buttons.TertiaryNormal
                    id='categories_clear_all'
                    onClick={clearAll}
                    style={{ marginLeft: '16px' }}
                  >
                    Clear All
                  </Buttons.TertiaryNormal>
                </S.BtnWrapp>
              )}
              <S.Wrap>
                <S.SelectedItem>
                  {categories
                    .filter((item) => item.selected || item.isGlobal)
                    .map((item) => (
                      <S.Item key={item?.value}>
                        <ParagraphWithTooltip text={item?.text} />
                        {item.isGlobal ? (
                          <CustomTooltip content={<LockIcon />} text='General Exclude' />
                        ) : (
                          <S.IconWrapp onClick={() => deleteCategory(item?.value)}>
                            <DeleteIcon />
                          </S.IconWrapp>
                        )}
                      </S.Item>
                    ))}
                </S.SelectedItem>
              </S.Wrap>
            </>
          )}
        </S.ActionField>
      </S.FieldsWrap>
    </>
  );
};

export default ExcludeCategories;
